import * as React from "react";
import {WithStyles, withStyles} from "@material-ui/core/styles";
import {ITodo, TODO_TYPE} from "@app-types/websocket/todo.types";
import Dialog from "@components/common/dialog/dialog.component";
import EditTodo from "./EditTodo";
import {EditTodoDialogStyle as styles} from "./EditTodoDialog.style";

interface IProps extends WithStyles<typeof styles> {
  open: boolean;
  close: () => void;
  todo?: ITodo;
  type?: TODO_TYPE;
  scheduleParents?: number[];
  scheduleChildren?: number[];
}

// The todo and packing item editor in the same frame as the event dialogs.
const EditTodoDialog = (props: IProps) => (
  <Dialog open={props.open} onClose={props.close} classes={{paper: props.classes.paper}}>
    <div className={props.classes.body}>
      <EditTodo closeContainer={props.close} todo={props.todo} type={props.type}
        scheduleParents={props.scheduleParents} scheduleChildren={props.scheduleChildren} />
    </div>
  </Dialog>
);

export default withStyles(styles)(EditTodoDialog);



// WEBPACK FOOTER //
// ./src/components/todo/EditTodoDialog.tsx